import {
  GrowthBook,
  GrowthBookProvider as OriginGrowthBookProvider,
} from '@growthbook/growthbook-react';
import { osName } from 'react-device-detect';

import { useEffect, PropsWithChildren } from 'react';

import { useGrowthBookProviderQuery } from 'common/apollo/graphql';
import useAuth from 'common/hooks/useAuth';
import { env } from 'utils/env';

const growthBook = new GrowthBook({
  apiHost: env.GROWTH_BOOK_API_HOST,
  clientKey: env.GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: env.STAGE !== 'prod',
});

function GrowthBookProvider({ children }: PropsWithChildren<{}>) {
  const { isAuthenticated } = useAuth();
  const { data: { me } = {} } = useGrowthBookProviderQuery({
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    growthBook.loadFeatures({ autoRefresh: true });
  }, []);

  useEffect(() => {
    if (me) {
      growthBook.setAttributes({
        id: me?.id,
        os: osName,
        enterprise: me?.enterprise?.id,
      });
    }
  }, [me]);

  return (
    <OriginGrowthBookProvider growthbook={growthBook}>
      {children}
    </OriginGrowthBookProvider>
  );
}

export default GrowthBookProvider;
